<div class="wrapper">
@for (m of menuItems; track m) {
  <div class="menu-card">
    @if (isDeleteVisible) {
      <div style="cursor:pointer;float: right; margin-top: -35px;">
        <div style="color:black; font-size: 16px;">
          <input type="checkbox" [(ngModel)]="m.isVisible" (change)="updateMenuItem(m)">
          <div (click)="_deleteMenuTemplate(m)" (keyup.enter)="_deleteMenuTemplate(m)" tabindex="0" role="button" style="color:red; font-size: 16px; float: right; padding-left: 10px;">
            Delete(x)
          </div>
        </div>
      </div>
    }
    <div class="menu-box">
      <div class="menu-text">
        <div class="menu-title"> {{m.title}} </div>
        <div class="menu-price">${{m.price}}</div>
      </div>
      @if (m.showDescription) {
        <div class="menu-description"> {{m.description}}</div>
      }
      <button class="add-text" disabled="true">Add</button>
    </div>
  </div>
}
</div>

